import ResponseModel from "../../models/response.model";
import axiosSetup from "../../utils/axiosSetup";

export const getProductionUnitsApi = async (params: {
  page: number;
  limit: number;
  search?: string;
  productId?: string;
  createdBy?: string;
  dispatchedStartDate?: string;
  dispatchedEndDate?: string;
  createdStartDate?: string;
  createdEndDate?: string;
  sortOrder?: "asc" | "desc";
}): Promise<ResponseModel> => {
  try {
    const path = "/factory/production-units";
    const res = await axiosSetup.get(path, { params });
    return res.data;
  } catch (error) {
    throw error;
  }
};
